import { Component, ElementRef, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { EcadashboardService } from './ecadashboard.services';
// import { SocketService } from '../../socket.service';

@Component({
  selector: 'app-ecadashboard',
  templateUrl: './ecadashboard.component.html',
  styleUrls: ['./ecadashboard.component.css']
})
export class EcadashboardComponent implements OnInit {
  @ViewChildren("checkboxes") checkboxes: QueryList<ElementRef>;

  currentYear = new Date().getFullYear();
  counts: any = {};
  tutorList;
  subAdminList;
  latestSessionList;
  sessionSelected = false;

  sessionCode = '';
  currentDate;
  timeStartHours;
  timeStartMinutes;
  timeStartHalf = '';
  timeEndHours;
  timeEndMinutes;
  timeEndHalf = '';
  sessionStartTimeStamp;
  sessionEndTimeStamp;
  topic = '';
  description = '';
  selectedTutors: any = {};
  tutorsArray: any[] = [];
  subAdminArray:any[]=[];


  invalidTimeError = false;
  emptyFieldError = false;

  sessionCreatedAlert = false;
  studentCreatedAlert = false;
  tutorCreatedAlert = false;
  subAdminCreatedAlert = false;

  studentData: any = {};
  tutorData: any = {};
  subAdminData: any = {};

  constructor(
    private router: Router,
    private  dashboardService:  EcadashboardService,
    // public SocketService:SocketService
  ) { }

  ngOnInit(): void {
    this.getDashboardDetails();
    this.getTutorList();
    this.getSubAdminList();

    this.invalidTimeError = false;
    this.emptyFieldError = false;
    this.sessionCreatedAlert = false;
    this.studentCreatedAlert = false;
    this.tutorCreatedAlert = false;
    this.subAdminCreatedAlert = false;
    this.sessionSelected = false
  }

  generateSessionCode() {
    let code = "";
    var possible = "0123456789";

    for (let i = 0; i < 6; i++)
    code += possible.charAt(Math.floor(Math.random() * possible.length));

    this.sessionCode = "EDT-" + code;
    console.log(this.sessionCode);
  }

  generateStudentCode() {
    let code = "";
    var possible = "0123456789";

    for (let i = 0; i < 6; i++)
    code += possible.charAt(Math.floor(Math.random() * possible.length));

    this.studentData.code = "ST-" + code;
    console.log(this.studentData.code);
  }

  generateTutorCode() {
    let code = "";
    var possible = "0123456789";

    for (let i = 0; i < 6; i++)
    code += possible.charAt(Math.floor(Math.random() * possible.length));

    this.tutorData.code = "TU-" + code;
    console.log(this.tutorData.code);
  }

  generateSubAdminPassword() {
    let code = "";
    var possible = "0123456789";

    for (let i = 0; i < 6; i++)
    code += possible.charAt(Math.floor(Math.random() * possible.length));

    this.subAdminData.password = "SA-" + code;
    console.log(this.subAdminData.password);
  }

  generateCurrentDate() {
    this.currentDate = new Date().toLocaleDateString();
  }

  onAddSessionClick() {
    this.generateSessionCode();
    this.generateCurrentDate();
    this.invalidTimeError = false;
    this.emptyFieldError = false;
    this.sessionCreatedAlert = false;
  }

  onAddStudentClick() {
    this.studentData = {};
    this.studentCreatedAlert = false;
    this.generateStudentCode();
  }

  onAddTutorClick() {
    this.tutorData = {};
    this.tutorCreatedAlert = false;
    this.generateTutorCode();
  }

  onAddSubAdminClick() {
    this.subAdminData = {};
    this.subAdminCreatedAlert = false;
    this.generateSubAdminPassword();
  }

  onCreateSession() {
    if (this.timeStartHalf == 'PM' && this.timeStartHours<12) {
      this.timeStartHours = this.timeStartHours + 12;
    }
    if(this.timeStartHalf == 'AM' && this.timeStartHours==12){
      this.timeStartHours = this.timeStartHours - 12;
    }
    this.sessionStartTimeStamp = new Date(this.currentDate + " " +this.timeStartHours+":"+this.timeStartMinutes+":00").getTime()/1000;

    if (this.timeEndHalf == 'PM' && this.timeEndHours<12){
      this.timeEndHours = this.timeEndHours + 12;
    }
    if(this.timeEndHalf == 'AM' && this.timeEndHours==12){
      this.timeEndHours = this.timeEndHours - 12;
    }
    this.sessionEndTimeStamp = new Date(this.currentDate + " " +this.timeEndHours+":"+this.timeEndMinutes+":00").getTime()/1000;

    this.invalidTimeError = false;
    this.emptyFieldError = false;
    this.sessionCreatedAlert = false;

    // if (this.timeStartHours < 0 || this.timeStartHours > 24 || this.timeStartMinutes <= 0 || this.timeStartMinutes >= 59 || this.timeEndHours < 0 || this.timeEndHours > 24 || this.timeEndMinutes <= 0 || this.timeEndMinutes >= 59) {
    //   this.invalidTimeError = true;
    // } else if (this.timeStartHours == '' || this.timeStartMinutes == '' || this.timeStartHalf == '' || this.timeEndHours == '' || this.timeEndMinutes == '' || this.timeEndHalf == '' || this.topic == '' || this.selectedTutors == {} || this.tutorsArray == []) {
    //   this.emptyFieldError = true;
    // } else {

      // console.log(this.sessionCode, this.currentDate, this.timeStartHours, this.timeStartMinutes, this.timeStartHalf, this.timeEndHours, this.timeEndMinutes, this.timeEndHalf, this.topic, this.description, this.selectedTutors);
      this.dashboardService.addSession({
        code: this.sessionCode,
        topic: this.topic,
        description: this.description,
        startTime: this.sessionStartTimeStamp,
        endTime: this.sessionEndTimeStamp,
        tutorId: this.tutorsArray,
        subAdminId:this.subAdminArray
      }).subscribe((dataResult: any) => {
       // console.log("sessionHit", dataResult);
        if(dataResult.success==true){
         // console.log("session added successfully!");
          this.checkboxes.forEach((element) => {
            element.nativeElement.checked = false;
          });
          this.sessionCreatedAlert = true;
          this.getDashboardDetails();

        }
        else {
          console.log("error found");
        }
      })

      this.sessionCode = '';
      this.currentDate = '';
      this.timeStartHours = '';
      this.timeStartMinutes = '';
      this.timeStartHalf = '';
      this.timeEndHours = '';
      this.timeEndMinutes = '';
      this.timeEndHalf = '';
      this.topic = '';
      this.description = '';
      this.selectedTutors = '';
      this.tutorsArray = [];
      this.subAdminArray=[];
    }
  // }

  // onAddStudent() {
  //   console.log(this.studentData);
  //   this.dashboardService.addStudent({email:this.studentData.email,
  //     name:this.studentData.name,
  //     contact:this.studentData.contact,
  //     location:this.studentData.location,
  //     class:this.studentData.class,
  //     studentCode:this.studentData.code,
  //     school: this.studentData.school
  //   }).subscribe((dataResult: any)=>{
  //     console.log("student",dataResult);
  //     if(dataResult.success==true){
  //       this.studentCreatedAlert = true;
  //       this.studentData = {};
  //       this.getDashboardDetails();
  //     }
  //     else {
  //       this.studentCreatedAlert = false;
  //     }
  //   })

  // }

  onAddTutor() {
    console.log(this.tutorData);
    this.dashboardService.addTutor({email:this.tutorData.email,
      name:this.tutorData.name,
      contact:this.tutorData.contact,
      location:this.tutorData.location,
      qualification:this.tutorData.qualification,
      tutorCode:this.tutorData.code,
    }).subscribe((dataResult: any)=>{
      console.log("sbadmin",dataResult);
      if(dataResult.success==true){
        this.tutorCreatedAlert = true;
        this.tutorData = {};
        this.getDashboardDetails();
      }
      else {
        this.tutorCreatedAlert = false;
      }
    })
  }

  onAddSubAdmin() {
    console.log(this.subAdminData);
    this.dashboardService.addSubAdmin({
      email: this.subAdminData.email,
      name: this.subAdminData.name,
      contact: this.subAdminData.contact,
      location: this.subAdminData.location,
      qualification: this.subAdminData.qualification,
      password: this.subAdminData.password
    }).subscribe((dataResult: any) => {
     // console.log("sbadmin", dataResult);
      if(dataResult.success==true){
        this.subAdminCreatedAlert = true;
        this.subAdminData = {};
        this.getDashboardDetails();
      }
      else {
        this.subAdminCreatedAlert = false;
      }
    })
  }

  getDashboardDetails(){
    this.dashboardService.adminDashboard().subscribe((dataResult: any)=>{
      console.log("admin dasboard",dataResult);
      this.counts = dataResult.list;
      this.latestSessionList = dataResult.list.sessionList;

      console.log(this.latestSessionList);
    })
  }

  getTutorList(){
    this.dashboardService.userList({userType:'TUTOR'}).subscribe((dataResult: any)=>{
      // console.log("tutor List",dataResult);
      this.tutorList = dataResult.list;
      console.log(this.tutorList);
    })
  }

  getSubAdminList(){
    this.dashboardService.userList({userType:'SUBADMIN'}).subscribe((dataResult: any)=>{
      console.log("sud admin List",dataResult);
      this.subAdminList = dataResult.list;
      console.log(this.subAdminList);
    })

  }

  onChecked(tutorId: string) {
    //console.log("click")
    let i = 0;

    for (let tutor of this.tutorsArray) {
      if (tutor == tutorId) {
          i = i+1;
          break;
      }
    }
    if (i==1) {
      console.log("found");
      delete this.tutorsArray[this.tutorsArray.findIndex(tutor => tutor == tutorId)];
      this.tutorsArray = this.tutorsArray.filter(e => e != null);
      i = 0;
    } else {
      console.log("not found");
      this.tutorsArray.push(tutorId);
      i = 0;
    }
   // console.log(this.tutorsArray);
  }

  onSubAdminChecked(subAdminId: string) {
    //console.log("click")
    let i = 0;

    for (let subAdmin of this.subAdminArray) {
      if (subAdmin == subAdminId) {
          i = i+1;
          break;
      }
    }
    if (i==1) {
      console.log("found");
      delete this.subAdminArray[this.subAdminArray.findIndex(tutor => tutor == subAdminId)];
      this.subAdminArray = this.subAdminArray.filter(e => e != null);
      i = 0;
    } else {
      console.log("not found");
      this.subAdminArray.push(subAdminId);
      i = 0;
    }
   // console.log(this.tutorsArray);
  }

  onSessionSelect(sessionId: string, sessionStatus: string) {
    this.sessionSelected = true;
    const userId = localStorage.getItem('userId');
    sessionStorage.setItem('sessionId',sessionId);
    // this.SocketService.sessionId.next(sessionId);
    // this.SocketService.sessionStatus.next(sessionStatus);
    let data={
      sessionId:sessionId,
      userId:userId
    }
    // this.SocketService.joinRoom(data);
  }
}
